import { takeEvery } from 'redux-saga/effects';

import * as messagesPageActions from 'store/modules/messagesPage';
import { loadChat } from './utils';

export default function* listenLoadChat() {
  yield takeEvery(messagesPageActions.loadChat.toString(), loadChat);
}
